/* eslint-disable no-unused-expressions, react/no-multi-comp */

import { KeyboardArrowDown } from '@material-ui/icons'
import cn from 'classnames'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import Icon from '../Icon'
import TableCell from './TableCell'

const StyledKeyboardArrowDown = styled(KeyboardArrowDown)`
  cursor: pointer;
  &.more {
    transform: rotate(-180deg);
    background-color: ${`var(--gameday-inputField-inputBGHover, ${theme.inputField.inputBGHover})`};
  }
`

const Row = styled.tr`
  &:hover td {
    border-bottom-color: var(--colors-teal);
    box-shadow: inset 0 -0.5px 0 var(--colors-teal);
  }
  &:hover td:has(.row-action) {
    box-shadow: -1px 1px 5px 0px var(--gameday-main-nav-toggle-color, #d5dee7), inset 0 -0.5px 0 var(--colors-teal);
  }
  position: relative;
  td {
    max-width: 320px;
    white-space: wrap;
    word-wrap: break-word;
    &:first-child {
      position: relative;
      padding-left: 9px;
    }
    &.dragging {
      width: 30px;
    }
    &:first-child::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      width: 3px;
    }
  }
  &.success {
    td {
      background-color: ${props => props.theme.status.successBG};
      border-color: ${props => props.theme.colors.white};
      &:first-child::before {
        background-color: ${props => props.theme.colors.green};
      }
    }
    &:hover {
      td {
        background-color: ${props => props.theme.status.successHover};
      }
    }
  }
  &.warning {
    td {
      background-color: ${props => props.theme.status.warningBG};
      border-color: ${props => props.theme.colors.white};
      &:first-child::before {
        background-color: ${props => props.theme.colors.yellow};
      }
    }
    &:hover {
      td {
        background-color: ${props => props.theme.status.warningHover};
      }
    }
  }
  &.info {
    td {
      background-color: ${props => props.theme.status.infoBG};
      border-color: ${props => props.theme.colors.white};
      &:first-child::before {
        background-color: ${props => props.theme.colors.blue};
      }
    }
    &:hover {
      td {
        background-color: ${props => props.theme.status.infoHover};
      }
    }
  }
  &.danger {
    td {
      background-color: ${props => props.theme.status.errorBG};
      border-color: ${props => props.theme.colors.white};
      &:first-child::before {
        background-color: ${props => props.theme.status.errorColor};
      }
    }
    &:hover {
      td {
        background-color: ${props => props.theme.status.errorHover};
      }
    }
  }
  &.disabled {
    td {
      background-color: ${`var(--gameday-table-tableRowLockedBgColor, ${theme.table.tableRowLockedBgColor})`};
    }
    td:not(:last-child) > .cell-data {
      opacity: 0.5;
    }
  }
  &.isLocked {
    td {
      background-color: ${`var(--gameday-table-tableRowLockedBgColor, ${theme.table.tableRowLockedBgColor})`};
      border-color: ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
      pointer-events: none;
      .cell-data {
        opacity: 0.7;
        margin-right: 2px;
      }
      &:last-child {
        text-align: right;
        padding-right: 16px;
      }
    }
  }
  &.dragging {
    display: table;
    border: ${theme.borders.default};
    border-collapse: separate;
    border-radius: 4px;
    background-color: ${`var(--gameday-table-rowDragBg, ${theme.table.rowDragBg})`};
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.2);
    td {
      border-top: none !important;
      border-bottom: none !important;
      &:before, &:after {
        display: none;
      }
    }
  }
  &.groupChild {
    background-color: var(--gameday-table-tableRowChildBgColor, ${theme.table.tableRowChildBgColor});
  }
  &.groupChild td:first-child {
    border-left: 0;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: -1px;
      bottom: -1px;
      width: 12px;
      background-color: var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor});
    }
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      left: 12px;
      height: 1px;
      background-color: var(--gameday-table-tableBorderColor, ${theme.table.tableBorderColor});
    }
  }
  &.groupChild td:last-child {
    position: relative;
    border-right: 0;
    &::before {
      content: "";
      position: absolute;
      right: 0;
      top: -1px;
      bottom: -1px;
      width: 12px;
      background-color: var(--gameday-table-tableHeaderRowBgColor, ${theme.table.tableHeaderRowBgColor});
    }
    &::after {
      right: 12px !important;
    }
  }

  & .draggableCell {
    color: var(--gameday-table-tableHeaderTextColor, ${theme.table.tableHeaderTextColor});
  }

  &:not(.groupChild) .draggableCell {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      right: 0;
      left: 0;
      height: 1px;
      background-color: var(--gameday-table-tableBorderColor, ${theme.table.tableBorderColor});
    }
  }

  & .draggableCell.belongsToHeader {
    padding-left: 20px;
    & + td {
      padding-left: 16px;
    }
  }

  &.isLocked.groupChild {
    td:first-child::before,
    td:last-child::before {
        background-color: ${props => props.theme.table.tableHeaderLockedBgColor};
      }
    }
  }
`

const TDExpandedRowRenderWrapper = styled.td`
  display: none;
  padding: 2em 2em;
  border-bottom: 0.25em solid ${`var(--gameday-borders-borderColor, ${theme.borders.borderColor})`};

  &.more {
    display: table-cell;
  }
  &.expandedRowRender {
    background-color: ${`var(--gameday-table-orderItemDetailTableBg, ${theme.table.orderItemDetailTableBg})`};
  }
`

class TDExpandedRowRender extends React.Component {
  rendered = false

  shouldComponentUpdate() {
    return true
  }

  renderChildren = () => {
    if (this.props.expandedRowRenderRefresh) {
      return this.props.more ? this.props.children : null
    }

    if (this.props.more) {
      this.rendered = true
      return this.props.children
    }

    return this.rendered ? this.props.children : null
  }

  render() {
    const { more, colSpan } = this.props

    return (
      <TDExpandedRowRenderWrapper colSpan={colSpan} className={cn('expandedRowRender', { more })}>
        {this.renderChildren()}
      </TDExpandedRowRenderWrapper>
    )
  }
}

class TableRow extends React.Component {
  state = {
    more: this.props.more,
  }

  shouldComponentUpdate() {
    return true
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.expandedRowRenderSetting.multiple && nextProps.more !== this.props.more) {
      this.setState({
        more: nextProps.more,
      })
    }
  }

  handleChangeCurrentExpandedRowOpen = () => {
    if (!this.props.expandedRowRenderSetting.multiple && !this.state.more) {
      return this.props.handleChangeCurrentExpandedRowOpen(this.props.rowKey)
    }

    if (!this.props.expandedRowRenderSetting.multiple && this.state.more) {
      return this.props.handleChangeCurrentExpandedRowOpen(null)
    }

    return this.setState(prevState => ({
      more: !prevState.more,
    }))
  }

  render() {
    const {
      className,
      headers,
      data,
      rowKey,
      ExpandedRowRender,
      expandedRowRenderSetting,
      handleChangeCurrentExpandedRowOpen,
      isDragging,
      noBorderCell,
      rowStatus,
      expandedRowColspan,
      // expandedRowClick,
      dragProps,
      isDraggable,
      classes,
      ...rest
    } = this.props
    const { more } = this.state
    return (
      <ThemeProvider theme={theme}>
        {/** biome-ignore lint/complexity/noUselessFragments: TODO */}
        <React.Fragment>
          <Row
            className={cn(
              data.status && data.action !== 'delete' && data.status.replace(/ /g, '').toLowerCase(),
              data.action === 'delete' && 'danger',
              data.isLocked && 'isLocked',
              rowStatus,
              'tableRow',
              data.belongsToHeader && !isDragging && 'groupChild',
              isDragging && 'dragging'
            )}
            {...dragProps}
            {...rest}
          >
            {ExpandedRowRender && (
              <TableCell
                className={cn({
                  'table-cell-has-expandedRowRender': more,
                  isDraggable,
                })}
                key="expandedRowRender"
                rowKey={rowKey}
                getValue={() => (
                  <StyledKeyboardArrowDown
                    className={cn({ more })}
                    onClick={this.handleChangeCurrentExpandedRowOpen}
                    aria-label="Expand"
                  />
                )}
                noBorderCell={noBorderCell}
              />
            )}
            {isDraggable && (
              <td className={cn(isDragging && 'dragging', 'draggableCell', data.belongsToHeader && 'belongsToHeader')}>
                {!data.isLocked && <Icon iconName="fieldDragHandle" iconSize="10" />}
              </td>
            )}
            {headers
              .filter(header => !header.isHiddenColumn && !header.isExportOnly)
              .map((header, i) => (
                <TableCell
                  // eslint-disable-next-line react/no-array-index-key
                  // biome-ignore lint/suspicious/noArrayIndexKey: TODO
                  key={i}
                  className={cn(data.belongsToHeader && !isDragging && 'isGroupChild', {
                    'table-cell-has-expandedRowRender': more,
                    isDraggable,
                  })}
                  header={header}
                  data={data}
                  rowKey={rowKey}
                  getValue={header.getValue}
                  noBorderCell={noBorderCell}
                />
              ))}
          </Row>
          {ExpandedRowRender && (
            <Row
              className={cn(
                !data.status || data.status.replace(/ /g, '').toLowerCase(),
                rowStatus,
                data.isLocked && classes.isLocked,
                data.action === 'delete' && classes.danger
              )}
              {...dragProps}
            >
              <TDExpandedRowRender
                colSpan={expandedRowColspan}
                more={more}
                expandedRowRenderRefresh={expandedRowRenderSetting.refresh}
              >
                <ExpandedRowRender rowKey={rowKey} headers={headers} data={data} />
              </TDExpandedRowRender>
            </Row>
          )}
        </React.Fragment>
      </ThemeProvider>
    )
  }
}

TableRow.defaultProps = {
  data: {},
  headers: [],
  handleChangeCurrentExpandedRowOpen: f => f,
  expandedRowRenderSetting: {
    refresh: false,
    multiple: true,
  },
  noBorderCell: false,
}

export default TableRow
